import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollDisableService {

  public renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
     private _renderer: RendererFactory2
  ) {
    this.renderer = _renderer.createRenderer(null, null);
  }


  stopScroll(className = 'scroll-disable-all'){
    this.renderer.addClass(this.document.body, className);
  }

  addScroll(className = 'scroll-disable-all'){
    this.renderer.removeClass(this.document.body, className);
  }
}
